import { render, staticRenderFns } from "./ImageObjectMenu.vue?vue&type=template&id=115ef78a&"
import script from "./ImageObjectMenu.vue?vue&type=script&lang=ts&"
export * from "./ImageObjectMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ImageObjectMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports